module.exports = __webpack_public_path__ + "img/logo_mark.0778503e.svg";